'use client'

import { twMerge } from '@/lib/classname/twMerge'
import { Checkbox } from '@/ui/form/inputs/checkbox/Checkbox.client'
import { cva } from 'class-variance-authority'
import {
  type TableHeaderProps as AriaTableHeaderProps,
  TableHeader as AriaTableHeader,
  Collection,
  useTableOptions,
} from 'react-aria-components'
import { useTable } from '../TableContext'
import { Column } from './Column.client'

export const tableHeaderVariants = ['light', 'primary', 'dark'] as const
type HeaderVariant = (typeof tableHeaderVariants)[number]

type TableHeaderProps = AriaTableHeaderProps<object> & {
  variant?: HeaderVariant
}

export const tableHeaderStyles = cva('', {
  variants: {
    variant: {
      light: 'bg-brand-2-50',
      primary: 'bg-brand-1-800 text-white',
      dark: 'bg-brand-2-900 text-white',
    },
  },
})

export function TableHeader({ columns, className, children, ...props }: TableHeaderProps) {
  const { selectionBehavior, selectionMode } = useTableOptions()
  const { variant } = useTable()

  return (
    <AriaTableHeader {...props} className={twMerge(className, tableHeaderStyles({ variant }))}>
      {selectionBehavior === 'toggle' && (
        <Column>{selectionMode === 'multiple' && <Checkbox slot="selection" />}</Column>
      )}

      {columns ? <Collection items={columns}>{children}</Collection> : <>{children}</>}
    </AriaTableHeader>
  )
}
